import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_CI_RIF_67 } from "@/lib/programs/ciudadesImperialesRif67";

export default function CiudadesImperialesRif67Page() {
  return <ProgramTemplate program={PROGRAM_CI_RIF_67} variant="ci" showJourneyChronology />;
}
